import styled from "styled-components";

export const Greeting = styled.p`
  color: #000;
  font-size: 1.6rem;
  font-style: italic;
`;
